// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2620":"572b7af5","2792":"df14d5c5"}[chunkId] + ".chunk.css";
};